// VIN Lookup Validator / Modal
// Please note VIN decoder does not decode cab configuration and/or bed length.
// Check your search results for the correct part.

var IsVinValid = false;

$(function() {

  var $VinInput = $('#VinInput');
  var $VinMsg   = $('#VinMsg');
  var $VinBtn   = $('#VinBtn');
  var $pfVinBtn = $('#pfVinBtn'); // (unused here but keeping as-is)

  var $VinGhost = $("#VinGhost");
  var $VinWrap  = $VinInput.closest(".vin-input-wrap");

  $VinInput.on('paste', function(e) { // trigger a keyup event when pasting from browser menu
    var pasteData = e.originalEvent.clipboardData.getData('text');
    $VinInput.val(pasteData.toUpperCase());
    $VinInput.keyup();
  });

  $VinInput.on("focus", updateVinGhost);

  //$VinInput.on("blur", function () {
  //  $VinWrap.removeClass("vin-left");
  //});

  // --- tab-to-complete ---
  $VinInput.on("keydown", function (e) {
    if (e.key === "Tab" || e.keyCode === 9) {
      var suggestion = $VinInput.data("vinSuggestion");
      if (suggestion) {
        e.preventDefault();
        var completed = $VinInput.val().toUpperCase() + suggestion;
        $VinInput.val(completed);
        validateVin(completed);
        updateVinGhost();
      }
    }
  });

  $VinInput.on('keyup', function(event) {
    
    updateVinGhost();
    
    if (validateVin($VinInput.val().toUpperCase())) {

      $VinMsg.html("VIN syntax is valid");
      $VinInput.css('background-color','rgba(0,255,0,0.4)');
      $VinMsg.css('background-color','rgba(0,255,0,0.4)');
      $VinBtn.css('background-color','#2e5a9f');
      $VinBtn.css('color','#fff');
      $VinBtn.prop('disabled', false);

      IsVinValid = true;
      
      //setVinCookie(vin);

      if (event.keyCode == 13) { // allow submit on enter key
        
        //$("#vin").val($VinInput.val().toUpperCase());
        var vin = $VinInput.val().toUpperCase();
        setVinCookie(vin);
        $("#vin").val(vin);
        
        $("#pfVinDialog").modal('hide');

        if (location.pathname.indexOf("/pages/product-finder") < 0) { // catches both production and dev (/product-finder)
          window.location = "/pages/product-finder/?vin=" + $VinInput.val().toUpperCase();
        } else {
          getResults();
        }
      }

    } else {

      if (event.keyCode == 13) event.preventDefault();

      $("#VinMsg").html("VIN syntax is not valid");
      $("#VinInput").css('background-color','rgba(255,0,0,0.2)');
      $("#VinMsg").css('background-color','rgba(255,0,0,0.2)');
      $("#VinBtn").css('background-color','#ececec');
      $("#VinBtn").prop('disabled', true);

      IsVinValid = false;
    }

  });

  $VinBtn.click(function() {

    if (IsVinValid) {

      //$("#vin").val($VinInput.val().toUpperCase());
      var vin = $VinInput.val().toUpperCase();
      setVinCookie(vin);
      $("#vin").val(vin);

      $("#pfVinDialog").modal('hide');

      if (location.pathname.indexOf("/product-finder") < 0) { // catches both production and dev (/product-finder)
        console.log('not on finder, redirect');
        window.location = "/pages/product-finder/?vin=" + $VinInput.val().toUpperCase();
      } else {
        getResults();
      }

    }

  });

  function updateVinGhost() {
    
    var typed = $VinInput.val().toUpperCase();
    var last = getVinCookie();
    var suggestion = "";

  if(typed.length > 0 && last && last.indexOf(typed) === 0 && last.length > typed.length) {
      suggestion = last.slice(typed.length);
    }

    $("#VinGhost").html(
      '<span class="typed">' + typed + '</span>' +
      '<span class="suggest">' + suggestion + '</span>'
    );

    $VinInput.data("vinSuggestion", suggestion);
    $VinInput.closest(".vin-input-wrap").toggleClass("vin-suggesting", suggestion.length > 0);
  
  }

  function updateVinGhostOFF() {
  
    var typed = $VinInput.val().toUpperCase();
    var last = getVinCookie();
    var suggestion = "";

    if (typed.length > 0 && last && last.indexOf(typed) === 0 && last.length > typed.length) {
      suggestion = last.slice(typed.length);
    }

    $("#VinGhost").html(
      '<span class="typed">' + typed + '</span>' +
      '<span class="suggest">' + suggestion + '</span>'
    );

    $VinInput.data("vinSuggestion", suggestion);
    $VinInput.closest(".vin-input-wrap").toggleClass("vin-left", $VinInput.is(":focus"));
  
  }

  // --- cookie helpers ---
  function setVinCookie(vin) {
    var d = new Date();
    d.setTime(d.getTime() + (180 * 24 * 60 * 60 * 1000));
    document.cookie = "lastVin=" + encodeURIComponent(vin) + ";expires=" + d.toUTCString() + ";path=/";
  }

  function getVinCookie() {
    var m = document.cookie.match(/(?:^|; )lastVin=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : null;
  }


  /* =========================================
     VIN OCR SCANNER CODE (DESKTOP: 1 BUTTON, MOBILE: 2 BUTTONS)
     -----------------------------------------
     Expected HTML IDs:
       Desktop button:  #vinUploadDesktopBtn
       Mobile buttons:  #vinTakePhotoMobileBtn, #vinUploadMobileBtn
       Hidden inputs:   #vinCameraInput (accept="image/*" capture="environment")
                        #vinLibraryInput (accept="image/*")
       Loader overlay:  #vinLoader
     ========================================= */

  const AK = 'AIzaSyDCTK9LHIuaFS6Ml8sjWDwtyjRf3jzHlQU';
  const AU = `https://vision.googleapis.com/v1/images:annotate?key=${AK}`;
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB limit

  const $loader = $('#vinLoader');

  // Buttons (show/hide via CSS breakpoint or media queries)
  const $uploadDesktopBtn   = $('#vinUploadDesktopBtn');
  const $takePhotoMobileBtn = $('#vinTakePhotoMobileBtn');
  const $uploadMobileBtn    = $('#vinUploadMobileBtn');

  // Hidden file inputs
  const $cameraInput  = $('#vinCameraInput');
  const $libraryInput = $('#vinLibraryInput');

  function openPicker($input) {
    // Reset so picking the same image twice still triggers change
    $input.val('');
    $input.trigger('click');
  }

  // Desktop: upload photo (library/file picker)
  $uploadDesktopBtn.on('click', function(e) {
    e.preventDefault();
    openPicker($libraryInput);
  });

  // Mobile: take photo (camera)
  $takePhotoMobileBtn.on('click', function(e) {
    e.preventDefault();
    openPicker($cameraInput);
  });

  // Mobile: upload existing (library/file picker)
  $uploadMobileBtn.on('click', function(e) {
    e.preventDefault();
    openPicker($libraryInput);
  });

  // Both inputs go through the same pipeline
  $cameraInput.on('change', function(e) {
    const file = e.target.files && e.target.files[0];
    handleSelectedFile(file, $cameraInput);
  });

  $libraryInput.on('change', function(e) {
    const file = e.target.files && e.target.files[0];
    handleSelectedFile(file, $libraryInput);
  });

  function resetInputs() {
    $cameraInput.val('');
    $libraryInput.val('');
  }

  function handleSelectedFile(file, $sourceInput) {
    if (!file) return;

    if (file.size > MAX_FILE_SIZE) {
      alert("File is too large! Please choose an image under 5MB.");
      $sourceInput.val('');
      return;
    }

    $loader.css('display', 'flex'); // Show loading overlay

    const reader = new FileReader();

    reader.onload = function(event) {
      const base64Content = event.target.result.split(',')[1];
      sendToGoogleVision(base64Content);
    };

    reader.onerror = function() {
      console.error('FileReader error');
      handleScanError("Could not read file. Please try again.");
    };

    reader.readAsDataURL(file);
  }

  // Send to Google Vision API
  async function sendToGoogleVision(base64Image) {
    const payload = {
      requests: [
        {
          image: { content: base64Image },
          features: [{ type: "TEXT_DETECTION" }]
        }
      ]
    };

    try {
      const response = await fetch(AU, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.responses && data.responses[0] && data.responses[0].fullTextAnnotation) {
        const fullText = data.responses[0].fullTextAnnotation.text;
        extractVIN(fullText);
      } else {
        handleScanError("No text detected. Try a clearer photo.");
      }

    } catch (error) {
      console.error('Error:', error);
      handleScanError("Connection error. Please type VIN manually.");
    }
  }

  // Parse VIN and update UI
  function extractVIN(text) {
    const vinRegex = /\b[A-HJ-NPR-Z0-9]{17}\b/g;
    const cleanText = text.toUpperCase();
    const matches = cleanText.match(vinRegex);

    if (matches && matches.length > 0) {
      const foundVin = matches[0];

      $loader.hide();
      resetInputs();

      // Trigger existing validation logic (greens/red based on check digit)
      $VinInput.val(foundVin).trigger('keyup');

      // If OCR found 17 chars but validation rejected it:
      if (!IsVinValid) {
        $VinMsg.html("17-digits found, but failed North American validation. Please check for typos.");
      }

    } else {
      handleScanError("No valid 17-digit VIN found. Try a clearer photo.");
    }
  }

  // Handle errors natively
  function handleScanError(errorMessage) {
    $loader.hide();
    resetInputs();

    // Re-use existing error state UI styles
    $VinMsg.html(errorMessage);
    $VinInput.css('background-color','rgba(255,0,0,0.2)');
    $VinMsg.css('background-color','rgba(255,0,0,0.2)');
    $VinBtn.css('background-color','#e5e5e5');
    $VinBtn.prop('disabled', true);
    IsVinValid = false;
  }

  /* =========================================
     VIN OCR SCANNER CODE ENDS HERE
     ========================================= */

});


// ... Keep your existing validateVin, vinReset, and .finder-getVin-btn click functions exactly as they are below ...

function validateVin(vin) {

  return validate(vin);

  function transliterate(c) {
    return '0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ'.indexOf(c) % 10;
  }

  function get_check_digit(vin) {
    var map = '0123456789X';
    var weights = '8765432X098765432';
    var sum = 0;
    for (var i = 0; i < 17; ++i)
      sum += transliterate(vin[i]) * map.indexOf(weights[i]);
    return map[sum % 11];
  }

  function validate(vin) {
    if (vin.length !== 17) return false;
    return get_check_digit(vin) === vin[8];
  }
}

function vinReset() {

  IsVinValid = false;
  $("#vin").val('');
  $('#VinInput').val('');
  $("#VinInput").css('background-color','rgba(255,0,0,0.2)');
  $("#VinMsg").html("VIN syntax is not valid");
  $("#VinMsg").css('background-color','rgba(255,0,0,0.2)');
  $("#VinBtn").css('background-color','#c5c5c5');
  $("#VinBtn").prop('disabled', true);
  //console.log('vin reset');

}

$('.finder-getVin-btn').click(function(){

  event.preventDefault();
  $('#pfVinDialog')
    .modal({
      useFlex:true,
      autofocus: false,  //prevents mobile keyboard from auto-opening when modal displays (which blocks the button visiblity)
      observeChanges: true, // This automatically triggers a 'refresh' if the content inside changes
      onVisible: function() {
      // This forces the modal to "re-center" itself 
      // once it's actually drawn on the screen.
      $(this).modal('refresh');
    },      
      onHidden: function() {
        vinReset();
      }
    })
    .modal('show');

  //when in test mode 
  //const url = new URL(window.location.href);

  // Check standard query string (?scanner=true)
  //const hasQueryParam = url.searchParams.get("scanner") === "true";

  // Check hash fragment (#scanner=true)
  //const hashParams = new URLSearchParams(url.hash.slice(1));
  //const hasHashParam = hashParams.get("scanner") === "true";

  // True if it's in either the query string OR the hash
  //const isScanner = hasQueryParam || hasHashParam;

  //if (isScanner) {
  //  $("#pfScanner").show();
  //}

});